import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import IconButtonWithText from 'srcReact/components/common2/IconButtonWithText'
import styles from './styles.module.scss'
import MixrSettings from './components/MixrSettings'
import MemberSettings from './components/MemberSettings'
import AdmissionSettings from './components/AdmissionSettings'

export default function AdvanceSettings({
  show,
  hasMixrSetting,
  hasMemberSetting,
  hasAdmission,
  containerCss,
  verticalLineCss,
  buttonWrapperCss,
  infoCss,
  innerContainerCss,
  editMode = false,
  routeProps
}) {
  const { t } = useTranslation()
  const { privacySetting, groupInfo } = useSelector((state) => state.createUpdateGroup)

  const [showMixrSettings, setShowMixrSettings] = useState(false)
  const [showMemberSettings, setShowMemberSettings] = useState(false)
  const [showAdmission, setShowAdmission] = useState(false)
  const [infoForEditReceived, setInfoForEditReceived] = useState(false)

  const [initialMixrSettingValue, setInitialMixrSettingValue] = useState('member-can-suggest')
  const [initialMemberSettingValue, setInitialMemberSettingValue] = useState({ age: 13 })
  const [initialAdmissionSetting, setInitialAdmissionSetting] = useState('automatic-approval')

  const containerRef = useRef(null)

  useEffect(() => {
    const pathname = routeProps?.location?.pathname
    if (pathname?.includes('settings/member')) {
      setTimeout(() => setShowAdmission(true), 500)
    }
  }, [])

  useEffect(() => {
    if (editMode && groupInfo && !infoForEditReceived) {
      setInfoForEditReceived(true)
      setInitialMixrSettingValue(groupInfo.members_can_suggest_mixr === 1 ? 'member-can-suggest' : 'only-you-plan')
      setInitialAdmissionSetting(groupInfo.automatic_approval_to_join === 1 ? 'automatic-approval' : 'need-approval')
      setInitialMemberSettingValue({ age: groupInfo.age_requirements })
    }
  }, [groupInfo])

  const showContainer = (type) => {
    setShowMixrSettings(false)
    setShowMemberSettings(false)
    setShowAdmission(false)
    if (type === 'mixr') {
      setShowMixrSettings(true)
    } else if (type === 'member') {
      setShowMemberSettings(true)
    } else {
      setShowAdmission(true)
    }
  }

  return (
    <div id='groupAdvanceSettings'>
      <p className={infoCss}>{t('group.createGroup.advanceSetting.title1')}</p>
      <div className={`${innerContainerCss} ${styles.wrapper}`}>
        {hasMixrSetting && (
          <IconButtonWithText
            icon='calendar24'
            selected={showMixrSettings}
            text={t('group.createGroup.advanceSetting.mixr.title')}
            onClick={() => showContainer('mixr')}
            textCSS={styles.advSettingMainButtonText}
          />
        )}
        {hasMemberSetting && (
          <IconButtonWithText
            selected={showMemberSettings}
            icon='groups24'
            text={t('group.createGroup.advanceSetting.member.title')}
            onClick={() => showContainer('member')}
            textCSS={styles.advSettingMainButtonText}
          />
        )}

        {privacySetting === 'public' && hasAdmission && (
          <IconButtonWithText
            selected={showAdmission}
            icon='handshake'
            text={t('group.createGroup.advanceSetting.admission.title')}
            onClick={() => showContainer('admission')}
            textCSS={styles.advSettingMainButtonText}
          />
        )}
      </div>
      <MixrSettings show={showMixrSettings} value={initialMixrSettingValue} editMode={editMode} />
      <MemberSettings
        value={initialMemberSettingValue}
        editMode={editMode}
        containerCSS={`${innerContainerCss} ${styles.memberSettings} ${showMemberSettings && styles.showContainer}`}
        titleCSS={styles.title}
        infoCSS={styles.memberSettingsInfo}
        optionsContainCSS={styles.memberSettingsOptions}
        buttonWrapperCSS={`${buttonWrapperCss} ${styles.buttons}`}
        dropdownContainerCSS={styles.dropdownContainer}
        dropdownLabelCSS={styles.dropdownLabel}
        dropdownSelectedItemCSS={styles.dropdownSelectedItem}
      />
      <AdmissionSettings
        show={showAdmission && privacySetting === 'public'}
        value={initialAdmissionSetting}
        editMode={editMode}
      />
    </div>
  )
}
